import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogContent,
  Stack,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { useState } from "react";
import { API_VERSION, API_RESULT } from "../../../enums/common.enum";
import useAxiosInstance from "../../../hooks/useAxiosInstance";
import { handleError, successToast } from "../../../utils/common";
import { useParams } from "react-router-dom";

export const CancelInvoiceModal = ({
  data,
  setData,
  open,
  onClose,
  invoice,
}: any) => {
  const privateInstance = useAxiosInstance();
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const activeBorrowerId = params?.borrowerId;

  const handleSubmit = async () => {
    if (!reason.trim()) return;

    try {
      setLoading(true);

      const res = await privateInstance.post(
        `${API_VERSION.V3}/borrowers/applications`,
        {
          ...invoice,
          application_id: invoice.application_id,
          borrower_id: activeBorrowerId,
          status: "cancelled",
          cancelled_reason: reason,
        },
      );

      if (res?.data?.status === API_RESULT.SUCCESS) {
        const updatedFields = res.data.response;

        setData((prev: any[]) =>
          prev.map((item) =>
            item.application_id === invoice.application_id
              ? {
                  ...item,
                  ...updatedFields,
                }
              : item,
          ),
        );

        successToast("Invoice cancelled successfully");
        setReason("");
        onClose();
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setReason("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogContent>
        <Stack spacing={2}>
          <Typography fontWeight={600} color="error">
            Cancel Invoice
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Please provide a reason for cancelling invoice{" "}
            <b>{invoice?.invoice_id}</b>
          </Typography>

          <TextField
            multiline
            rows={4}
            fullWidth
            label="Cancellation Reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />

          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button variant="outlined" onClick={onClose}>
              Close
            </Button>

            <LoadingButton
              variant="contained"
              color="error"
              loading={loading}
              disabled={!reason.trim()}
              onClick={handleSubmit}
            >
              Submit
            </LoadingButton>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
